module.exports = __webpack_public_path__ + "img/control_device2.48c5678d.png";